module.exports = __webpack_public_path__ + "img/negative-end-screen.7a094e87.svg";